/* eslint-disable no-bitwise */
import React, { useEffect, useState } from 'react'
import { Input, Modal, Segment } from 'semantic-ui-react'
import { AppDropdown as Dropdown } from 'components/AppDropdown'
import { X } from 'phosphor-react'
import { FlexRowBetween, TitleText } from 'components'
import { ShareEmailSubjectFormatService } from 'utility'
import { useNotification } from 'hooks'
import { SubmitCancelButtons } from 'elements'

const formatBuilderStyles = `
.format-builder-wrap {
  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 12px;
  padding: 8px 4px 0;
  font-family: inherit;
}
.format-builder-wrap h1 {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #101828 !important;
  margin: 0 0 4px 0 !important;
}
.format-builder-wrap .subtitle {
  font-size: 13px;
  color: #667085;
  margin-bottom: 20px;
}
.fb-card {
  background: #ffffff;
  border: 1px solid #f2f4f7;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);
}
.fb-card.preview-card {
  background: #fcfcfd;
  border: 1px solid #eaecf0;
}
.preview-label {
  font-size: 11px;
  font-weight: 600;
  color: #344054;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}
.preview-box {
  background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);
  color: #68d391;
  padding: 16px 18px;
  border-radius: 10px;
  font-family: monospace;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-align: center;
  word-break: break-word;
  white-space: normal;
  line-height: 1.45;
}
.preview-sub {
  font-size: 12px;
  color: #475467;
  margin-bottom: 16px;
  width: 100%;
  text-align: center;
}
.format-string {
  font-size: 14px;
  font-weight: 600;
  color: #475467;
  font-family: monospace;
  background: #f2f4f7;
  padding: 8px 12px;
  border-radius: 6px;
  display: inline-block;
}
.row-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.fb-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 8px;
  transition: all 0.2s ease;
  user-select: none;
}
.fb-row.dragging {
  opacity: 0.5;
  background: #f9fafb;
  border-style: dashed;
}
.fb-row.disabled {
  background: #f8f9fa;
  border-color: #eaecf0;
  opacity: 0.75;
}
.drag-handle {
  font-size: 18px;
  color: #98a2b3;
  margin-right: 6px;
  cursor: grab;
  font-weight: bold;
  flex-shrink: 0;
}
.fb-row:not(.disabled) .drag-handle:active {
  cursor: grabbing;
}
.fb-toggle {
  width: 40px;
  height: 20px;
  background: #eaecf0;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: background 0.2s ease;
  margin-right: 6px;
  flex-shrink: 0;
}
.fb-toggle.on {
  background: #12b76a;
}
.fb-toggle-knob {
  width: 14px;
  height: 14px;
  background: #ffffff;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: transform 0.2s ease;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.06);
}
.fb-toggle.on .fb-toggle-knob {
  transform: translateX(20px);
}
.row-label {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 140px;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
}
.row-label .hint {
  font-size: 12px;
  font-weight: 400;
  color: #667085;
  margin-top: 2px;
}
.row-control {
  margin-left: auto;
  flex-shrink: 0;
  max-width: 100%;
}
.row-control input[type="text"],
.row-control select,
.global-row input[type="text"],
.global-row select {
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  color: #344054;
  outline: none;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  min-width: 160px;
  max-width: 100%;
}
.row-control input[type="text"]:focus,
.row-control select:focus,
.global-row input[type="text"]:focus,
.global-row select:focus {
  border-color: #84caff;
  box-shadow: 0px 0px 0px 3px rgba(132, 202, 255, 0.25);
}
.fb-row.disabled .row-control input,
.fb-row.disabled .row-control select {
  background: #f2f4f7;
  color: #98a2b3;
  cursor: not-allowed;
}
.global-section {
  border-top: 1px solid #eaecf0;
  margin-top: 20px;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.global-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}
.global-row .row-label {
  flex-grow: 1;
}
@media (max-width: 768px) {
  .format-builder-wrap {
    padding: 0;
  }
  .fb-card {
    padding: 12px;
  }
  .preview-box {
    font-size: 13px;
    padding: 12px;
    text-align: left;
  }
  .format-string {
    font-size: 12px;
    display: block;
    white-space: normal;
    word-break: break-word;
    margin-top: 6px;
  }
  .fb-row {
    align-items: flex-start;
  }
  .row-control {
    margin-left: 0;
    width: 100%;
  }
  .row-control .ui.input,
  .row-control .ui.dropdown,
  .global-row .ui.input,
  .global-row .ui.dropdown {
    width: 100% !important;
    min-width: 0 !important;
  }
  .row-control input[type="text"],
  .global-row input[type="text"] {
    width: 100%;
    min-width: 0;
  }
  .global-row {
    flex-direction: column;
    align-items: stretch;
  }
}
`

const TOKEN_BITS = {
    PREFIX: 1,
    TEMPLATE: 2,
    COMPANY: 4,
    CUSTOMER: 8,
    AUDIT_NAME: 16,
    AUDITOR: 32,
    DATE: 64,
    SUFFIX: 128,
}

const ALL_TOKEN_KEYS = [
    'PREFIX',
    'TEMPLATE',
    'COMPANY',
    'CUSTOMER',
    'AUDIT_NAME',
    'AUDITOR',
    'DATE',
    'SUFFIX',
]

const buildDefaultTokens = (cfg = {}) => {
    const {
        PrefixText = '',
        SuffixText = '',
        TemplateFormat = 0,
        CompanyFormat = 0,
        CustomerFormat = 0,
        AuditNameFormat = 0,
        AuditorFormat = 0,
        DateFormat = 0,
        EnabledMask = 0,
    } = cfg

    return [
        {
            key: 'PREFIX',
            label: 'Prefix',
            hint: 'Static text at the start (e.g. [eAuditor], [ACME])',
            type: 'input',
            value: PrefixText || '',
            enabled: (EnabledMask & TOKEN_BITS.PREFIX) !== 0,
            maxLength: 50,
        },
        {
            key: 'TEMPLATE',
            label: 'Template Name',
            hint: 'The template used for the audit (e.g. "Hygiene Weekly")',
            type: 'select',
            value: String(TemplateFormat ?? 0),
            enabled: (EnabledMask & TOKEN_BITS.TEMPLATE) !== 0,
            options: [
                { value: '0', label: 'Full' },
                { value: '1', label: 'Short — first word' },
                { value: '2', label: 'No spaces' },
            ],
        },
        {
            key: 'COMPANY',
            label: 'Company Name',
            hint: 'The company running the audit (e.g. "Cintas")',
            type: 'select',
            value: String(CompanyFormat ?? 0),
            enabled: (EnabledMask & TOKEN_BITS.COMPANY) !== 0,
            options: [
                { value: '0', label: 'Full' },
                { value: '1', label: 'Short' },
                { value: '2', label: 'Initials' },
            ],
        },
        {
            key: 'CUSTOMER',
            label: 'Customer Name',
            hint: 'The audited customer / location (e.g. "City Grocery")',
            type: 'select',
            value: String(CustomerFormat ?? 0),
            enabled: (EnabledMask & TOKEN_BITS.CUSTOMER) !== 0,
            options: [
                { value: '0', label: 'Full' },
                { value: '1', label: 'Initials' },
                { value: '2', label: 'No spaces' },
            ],
        },
        {
            key: 'AUDIT_NAME',
            label: 'Audit Name / #',
            hint: 'Free-form audit name or auto-incrementing ID',
            type: 'select',
            value: String(AuditNameFormat ?? 0),
            enabled: (EnabledMask & TOKEN_BITS.AUDIT_NAME) !== 0,
            options: [
                { value: '0', label: 'Audit Name (if set) else Audit #' },
                { value: '1', label: 'Audit # only' },
                { value: '2', label: 'Audit Name only' },
            ],
        },
        {
            key: 'AUDITOR',
            label: 'Auditor',
            hint: 'The user who conducted the audit',
            type: 'select',
            value: String(AuditorFormat ?? 0),
            enabled: (EnabledMask & TOKEN_BITS.AUDITOR) !== 0,
            options: [
                { value: '0', label: 'Full name' },
                { value: '1', label: 'First name only' },
                { value: '2', label: 'Initials' },
            ],
        },
        {
            key: 'DATE',
            label: 'Date',
            hint: 'Audit completion date, rendered in the timezone below',
            type: 'select',
            value: String(DateFormat ?? 0),
            enabled: (EnabledMask & TOKEN_BITS.DATE) !== 0,
            options: [
                { value: '0', label: 'YYYY-MM-DD' },
                { value: '1', label: 'MMM D, YYYY' },
                { value: '2', label: 'MM/DD/YYYY' },
                { value: '3', label: 'DD/MM/YYYY' },
                { value: '4', label: 'YYYY-MM-DD HH:mm' },
            ],
        },
        {
            key: 'SUFFIX',
            label: 'Suffix',
            hint: 'Static text at the end (e.g. "— Please review", "[URGENT]")',
            type: 'input',
            value: SuffixText || '',
            enabled: (EnabledMask & TOKEN_BITS.SUFFIX) !== 0,
            maxLength: 50,
            placeholder: 'e.g. — Please review',
        },
    ]
}

const orderTokens = (defaultTokens, tokenOrderCsv) => {
    if (!tokenOrderCsv) {
        return pinPrefixSuffix(defaultTokens)
    }

    const keys = tokenOrderCsv
        .split(',')
        .map(k => k.trim().toUpperCase())
        .filter(k => ALL_TOKEN_KEYS.includes(k))

    const ordered = []
    const seen = new Set()

    keys.forEach(k => {
        const found = defaultTokens.find(t => t.key === k)
        if (found && !seen.has(k)) {
            ordered.push(found)
            seen.add(k)
        }
    })

    defaultTokens.forEach(t => {
        if (!seen.has(t.key)) {
            ordered.push(t)
        }
    })

    return pinPrefixSuffix(ordered)
}

/** Backend always renders PREFIX first and SUFFIX last when enabled. */
const pinPrefixSuffix = tokens => {
    const prefix = tokens.find(t => t.key === 'PREFIX')
    const suffix = tokens.find(t => t.key === 'SUFFIX')
    const middle = tokens.filter(t => t.key !== 'PREFIX' && t.key !== 'SUFFIX')
    const result = []
    if (prefix) result.push(prefix)
    result.push(...middle)
    if (suffix) result.push(suffix)
    return result
}

const buildPayload = (tokens, separator, timezoneMode) => {
    const ordered = pinPrefixSuffix(tokens)
    const activeTokens = ordered.filter(t => t.enabled)
    const tokenOrderCsv = activeTokens.map(t => t.key).join(',')

    let enabledMask = 0
    ordered.forEach(t => {
        if (t.enabled) {
            enabledMask |= TOKEN_BITS[t.key] || 0
        }
    })

    const getToken = key => ordered.find(t => t.key === key)
    const getFormat = key => {
        const token = getToken(key)
        return token ? parseInt(token.value, 10) || 0 : 0
    }

    return {
        tokenOrderCsv,
        enabledMask,
        prefixText: getToken('PREFIX')?.value ?? '',
        suffixText: getToken('SUFFIX')?.value ?? '',
        templateFormat: getFormat('TEMPLATE'),
        companyFormat: getFormat('COMPANY'),
        customerFormat: getFormat('CUSTOMER'),
        auditNameFormat: getFormat('AUDIT_NAME'),
        auditorFormat: getFormat('AUDITOR'),
        dateFormat: getFormat('DATE'),
        separator,
        timezoneMode: parseInt(timezoneMode, 10) || 0,
    }
}

export const ShareEmailSubjectFormatModal = ({ open, onClose, onSaved }) => {
    const { successToast, errorToast } = useNotification()

    const [tokens, setTokens] = useState([])
    const [separator, setSeparator] = useState(' - ')
    const [timezoneMode, setTimezoneMode] = useState('0')
    const [preview, setPreview] = useState('—')

    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)
    const [loadingPreview, setLoadingPreview] = useState(false)
    const [draggedIndex, setDraggedIndex] = useState(null)

    useEffect(() => {
        const styleId = 'share-email-subject-format-builder-styles'
        let styleElement = document.getElementById(styleId)
        if (!styleElement) {
            styleElement = document.createElement('style')
            styleElement.id = styleId
            document.head.appendChild(styleElement)
        }
        styleElement.innerHTML = formatBuilderStyles
    }, [])

    useEffect(() => {
        if (!open) return undefined

        let cancelled = false

        const fetchConfig = async () => {
            try {
                setLoading(true)
                const res = await ShareEmailSubjectFormatService.get()
                if (cancelled || !res) return

                const cfg = {
                    PrefixText: res.PrefixText ?? '',
                    SuffixText: res.SuffixText ?? '',
                    TemplateFormat: res.TemplateFormat ?? 0,
                    CompanyFormat: res.CompanyFormat ?? 0,
                    CustomerFormat: res.CustomerFormat ?? 0,
                    AuditNameFormat: res.AuditNameFormat ?? 0,
                    AuditorFormat: res.AuditorFormat ?? 0,
                    DateFormat: res.DateFormat ?? 0,
                    EnabledMask: res.EnabledMask ?? 0,
                }

                setSeparator(res.Separator ?? ' - ')
                setTimezoneMode(String(res.TimezoneMode ?? 0))
                setPreview(res.Preview || '—')
                setTokens(orderTokens(buildDefaultTokens(cfg), res.TokenOrderCsv))
            } catch (err) {
                console.error('Failed to load share email subject format', err)
                errorToast('Failed to load email subject format settings')
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        fetchConfig()

        return () => {
            cancelled = true
        }
    }, [open])

    useEffect(() => {
        if (!open || tokens.length === 0) return undefined

        const fetchPreview = async () => {
            try {
                setLoadingPreview(true)
                const payload = buildPayload(tokens, separator, timezoneMode)
                const res = await ShareEmailSubjectFormatService.preview(payload)
                const previewVal =
                    res?.Preview ||
                    res?.preview ||
                    res?.data?.Preview ||
                    (typeof res === 'string' ? res : '—')
                setPreview(previewVal)
            } catch (err) {
                console.error('Failed to get email subject preview', err)
            } finally {
                setLoadingPreview(false)
            }
        }

        const timer = setTimeout(fetchPreview, 300)
        return () => clearTimeout(timer)
    }, [open, tokens, separator, timezoneMode])

    const handleToggle = key => {
        setTokens(prev =>
            prev.map(t => (t.key === key ? { ...t, enabled: !t.enabled } : t)),
        )
    }

    const handleValueChange = (key, value) => {
        setTokens(prev =>
            prev.map(t => (t.key === key ? { ...t, value } : t)),
        )
    }

    const handleDragStart = (e, index) => {
        const token = tokens[index]
        if (!token?.enabled || token.key === 'PREFIX' || token.key === 'SUFFIX') {
            e.preventDefault()
            return
        }
        setDraggedIndex(index)
        e.dataTransfer.effectAllowed = 'move'
    }

    const handleDragOver = e => {
        e.preventDefault()
    }

    const handleDrop = (e, index) => {
        e.preventDefault()
        if (draggedIndex === null || draggedIndex === index) return

        const target = tokens[index]
        if (target?.key === 'PREFIX' || target?.key === 'SUFFIX') {
            setDraggedIndex(null)
            return
        }

        const updated = [...tokens]
        const [removed] = updated.splice(draggedIndex, 1)
        updated.splice(index, 0, removed)
        setTokens(pinPrefixSuffix(updated))
        setDraggedIndex(null)
    }

    const handleDragEnd = () => {
        setDraggedIndex(null)
    }

    const handleSave = async () => {
        const payload = buildPayload(tokens, separator, timezoneMode)
        if (!payload.enabledMask) {
            errorToast('Enable at least one part of the email subject')
            return
        }

        try {
            setSaving(true)
            const res = await ShareEmailSubjectFormatService.save(payload)
            const savedPreview = res?.Preview || res?.preview || preview
            successToast('Share report email subject format saved')
            if (onSaved) onSaved(savedPreview)
            onClose()
        } catch (err) {
            console.error('Failed to save email subject format', err)
            const message =
                err?.error?.Message ||
                err?.error?.message ||
                (typeof err?.error === 'string' ? err.error : null) ||
                'Failed to save email subject format'
            errorToast(message)
        } finally {
            setSaving(false)
        }
    }

    const formatStringPreview = () => {
        const active = pinPrefixSuffix(tokens).filter(t => t.enabled)
        if (!active.length) return '—'
        return active.map(t => `{${t.key}}`).join(separator)
    }

    return (
        <Modal open={open} onClose={onClose} size="large">
            <Modal.Header>
                <FlexRowBetween>
                    <TitleText>Share Report Email Subject Format</TitleText>
                    <X className="pointer" size={32} onClick={onClose} />
                </FlexRowBetween>
            </Modal.Header>
            <Modal.Content style={{ maxHeight: '75vh', overflow: 'auto' }}>
                {loading ? (
                    <Segment basic style={{ minHeight: '240px' }} loading>
                        <div
                            style={{
                                padding: '60px',
                                textAlign: 'center',
                                color: '#667085',
                            }}
                        >
                            Loading Format Settings...
                        </div>
                    </Segment>
                ) : (
                    <div className="format-builder-wrap">
                        <div className="subtitle">
                            Toggle parts on or off. Drag the{' '}
                            <span style={{ color: '#6c757d', fontWeight: '600' }}>
                                ⋮⋮
                            </span>{' '}
                            handle to reorder. Preview is rendered live from the
                            backend using a sample audit.
                        </div>

                        <div
                            className="fb-card preview-card"
                            style={{ position: 'relative' }}
                        >
                            {loadingPreview && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '10px',
                                        right: '10px',
                                        fontSize: '11px',
                                        color: '#84caff',
                                    }}
                                >
                                    Updating...
                                </div>
                            )}
                            <div className="preview-label">
                                Live Preview{' '}
                                <span
                                    style={{
                                        fontWeight: '400',
                                        textTransform: 'none',
                                        letterSpacing: 0,
                                        color: '#98a2b3',
                                    }}
                                >
                                    — rendered from backend
                                </span>
                            </div>
                            <div className="preview-box">{preview}</div>
                            <div
                                className="preview-sub"
                                style={{ marginTop: '8px' }}
                            >
                                Format String:{' '}
                                <span className="format-string">
                                    {formatStringPreview()}
                                </span>
                            </div>
                        </div>

                        <div className="fb-card">
                            <div className="row-list">
                                {tokens.map((t, idx) => {
                                    const isDragging = idx === draggedIndex
                                    const isPinned =
                                        t.key === 'PREFIX' || t.key === 'SUFFIX'
                                    const canDrag = t.enabled && !isPinned
                                    let dragTitle = 'Enable part to reorder'
                                    if (t.key === 'PREFIX') {
                                        dragTitle = 'Prefix is always first'
                                    } else if (t.key === 'SUFFIX') {
                                        dragTitle = 'Suffix is always last'
                                    } else if (t.enabled) {
                                        dragTitle = 'Drag to reorder'
                                    }
                                    return (
                                        <div
                                            key={t.key}
                                            className={`fb-row ${
                                                !t.enabled ? 'disabled' : ''
                                            } ${isDragging ? 'dragging' : ''}`}
                                            draggable={canDrag}
                                            onDragStart={e =>
                                                handleDragStart(e, idx)
                                            }
                                            onDragOver={handleDragOver}
                                            onDrop={e => handleDrop(e, idx)}
                                            onDragEnd={handleDragEnd}
                                        >
                                            <span
                                                className="drag-handle"
                                                style={{
                                                    cursor: canDrag
                                                        ? 'grab'
                                                        : 'not-allowed',
                                                    opacity: isPinned
                                                        ? 0.35
                                                        : 1,
                                                }}
                                                title={dragTitle}
                                            >
                                                ⋮⋮
                                            </span>

                                            <div
                                                className={`fb-toggle ${
                                                    t.enabled ? 'on' : ''
                                                }`}
                                                onClick={() =>
                                                    handleToggle(t.key)
                                                }
                                            >
                                                <div className="fb-toggle-knob" />
                                            </div>

                                            <label className="row-label">
                                                {t.label}
                                                <span className="hint">
                                                    {t.hint}
                                                </span>
                                            </label>

                                            <div className="row-control">
                                                {t.type === 'input' ? (
                                                    <Input
                                                        type="text"
                                                        value={t.value}
                                                        disabled={!t.enabled}
                                                        maxLength={
                                                            t.maxLength || 50
                                                        }
                                                        placeholder={
                                                            t.placeholder
                                                        }
                                                        onChange={e =>
                                                            handleValueChange(
                                                                t.key,
                                                                e.target.value,
                                                            )
                                                        }
                                                        style={{
                                                            minWidth: '220px',
                                                        }}
                                                    />
                                                ) : (
                                                    <Dropdown
                                                        selection
                                                        disabled={!t.enabled}
                                                        value={t.value}
                                                        options={t.options.map(
                                                            o => ({
                                                                key: o.value,
                                                                value: o.value,
                                                                text: o.label,
                                                            }),
                                                        )}
                                                        onChange={(_, data) =>
                                                            handleValueChange(
                                                                t.key,
                                                                data.value,
                                                            )
                                                        }
                                                        style={{
                                                            minWidth: '220px',
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                            <div className="global-section">
                                <div className="global-row">
                                    <label className="row-label">
                                        Separator
                                        <span className="hint">
                                            Character(s) between parts
                                        </span>
                                    </label>
                                    <Input
                                        type="text"
                                        value={separator}
                                        maxLength={10}
                                        onChange={e =>
                                            setSeparator(
                                                e.target.value.substring(0, 10),
                                            )
                                        }
                                        style={{ minWidth: '240px' }}
                                    />
                                </div>

                                <div className="global-row">
                                    <label className="row-label">
                                        Timezone for Date token
                                        <span className="hint">
                                            Which timezone to render the date in
                                        </span>
                                    </label>
                                    <Dropdown
                                        selection
                                        value={timezoneMode}
                                        options={[
                                            {
                                                key: '0',
                                                value: '0',
                                                text: 'Company default',
                                            },
                                            {
                                                key: '1',
                                                value: '1',
                                                text: "Auditor's local timezone",
                                            },
                                            {
                                                key: '2',
                                                value: '2',
                                                text: 'UTC',
                                            },
                                        ]}
                                        onChange={(_, data) =>
                                            setTimezoneMode(data.value)
                                        }
                                        style={{ minWidth: '240px' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Modal.Content>
            <Modal.Actions>
                <SubmitCancelButtons
                    loading={saving || loading}
                    onSubmit={handleSave}
                    onCancel={onClose}
                />
            </Modal.Actions>
        </Modal>
    )
}
